'use client'

import LoadingText from '../../components/LoadingText'
import type { LoadableComponentProps } from '../../types'
import BenefitCard from './BenefitCard'

export type BenefitCardsProps = {
  title: string
  benefits: {
    title: string
    benefitCode: string
    state: 'active' | 'inactive' | 'used' | 'activeAutomatically'
  }[]
  labels: {
    active: { status: string; button: string }
    inactive: { status: string; button: string }
    used: { status: string }
    activeAutomatically: { status: string }
  }
  onActivate: (benefitCode: string) => Promise<void>
  onDeactivate: (benefitCode: string) => Promise<void>
}

export default function BenefitCards({ data, loading }: LoadableComponentProps<BenefitCardsProps>) {
  const {
    title,
    benefits,
    labels,
    onActivate = () => Promise.resolve(),
    onDeactivate = () => Promise.resolve(),
  } = data || {}

  return (
    <div
      className='isolate mx-auto px-5 py-10'
      style={{ maxWidth: 'var(--layout-max-width, none)' }}
    >
      <h2 className='h5 mb-6'>
        {loading ? <LoadingText className='inline' textLength={15} /> : title}
      </h2>
      <div className='grid grid-cols-2 gap-4 even:grow sm:flex sm:flex-wrap'>
        {loading
          ? Array.from({ length: 3 }).map((_, index) => (
              <BenefitCard key={index} data={undefined} loading={true} />
            ))
          : benefits?.map(
              benefit =>
                labels && (
                  <BenefitCard
                    key={benefit.benefitCode}
                    data={{
                      ...benefit,
                      className: '!max-w-none sm:!max-w-[220px] sm:w-[220px]',
                      labels,
                      onActivate,
                      onDeactivate,
                    }}
                    loading={false}
                  />
                ),
            )}
      </div>
    </div>
  )
}
